'use client';

import { useState } from 'react';

import {
    Align,
    Icon,
    IconName,
    IconSize,
    Justify,
    Row,
    Rows,
    Section,
    Spacer,
    SpacerSize,
    TrilogyColor,
    View,
} from '@bytel/trilogy-react';

import { OptionType, PlanType } from '@app-types/product';

import { ProductsCatalog } from '@landing/components';

export default function CatalogOffers({
    catalog,
    blockedOption,
}: Readonly<{ catalog: PlanType[]; blockedOption?: OptionType }>) {
    const [isOpened, setIsOpened] = useState(false);

    return (
        <>
            <Spacer size={SpacerSize.SIX} />
            <Rows gap={2}>
                <Row>
                    <View
                        flexable
                        align={Align.CENTER}
                        justify={Justify.CENTER}
                        onClick={() => {
                            setIsOpened(!isOpened);
                        }}
                    >
                        <button className='button-clear link is-marginless'>
                            {isOpened ? 'Masquer ces forfaits' : 'Afficher les autres forfaits B&You'}
                        </button>
                        <Icon name={isOpened ? IconName.ARROW_UP : IconName.ARROW_DOWN} size={IconSize.SMALL} />
                    </View>
                </Row>
                <Spacer size={SpacerSize.FOUR} />
                {isOpened && (
                    <Row>
                        <Section backgroundColor={TrilogyColor.NEUTRAL_FADE}>
                            <ProductsCatalog catalogue={catalog} blockedOption={blockedOption} />
                        </Section>
                    </Row>
                )}
            </Rows>
        </>
    );
}
